import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedDate, FormattedTime } from 'components/intl'
import { compose } from 'recompose'

import { File } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { Button, Status, ButtonGroup } from 'components/misc'
import { Title } from 'components/layout'
import { files as filesLayout } from 'constants/layout'
import { modal } from 'redux/modules/app'
import config from 'config'

const enhance = compose(withRouter, connect(null, { modal }))

class FilesList extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    params: PropTypes.object.isRequired,
    files: PropTypes.array.isRequired,
    modal: PropTypes.func.isRequired,
    hasTitle: PropTypes.bool,
    onDisplayDetail: PropTypes.func,
    onEditFile: PropTypes.func,
    clickable: PropTypes.bool,
    loading: PropTypes.bool
  }
  static defaultProps = {
    files: [],
    params: {},
    hasTitle: true,
    clickable: true
  }

  key = uuid.v1()

  handleDeleteModal = idToRemove => {
    this.setState({ idToRemove }, () =>
      this.props.modal(`modal-file-delete-${this.key}`)
    )
  }

  render() {
    const {
      files,
      params,
      hasTitle,
      onDisplayDetail,
      clickable,
      awardId,
      loading
    } = this.props

    return (
      <div className="base-margin--top">
        {hasTitle &&
          <Title h2 intlKey="moduleTitle.files">
            Files
          </Title>}
        <Table
          ths={filesLayout.tableHeaders}
          length={files.length}
          loading={loading}
        >
          <Data>
            {files.map(({
              id,
              fileUrl,
              canBeDeleted,
              title,
              description,
              author,
              createdAt,
              isAssessorReportFile,
              isParentalConsentFile,
              isObservationFile,
              section,
              category
            }) => (
              <tr key={id}>
                <td>
                  {fileUrl &&
                    <File
                      src={fileUrl}
                      title={title}
                      clickable={clickable}
                      withAuthCode
                    />}
                </td>
                <td>
                  {onDisplayDetail
                    ? <span>{title}</span>
                    : <Link to={`${config.publicPath}/awards/${awardId || params.id}/files/${id}`}>
                        {title}
                      </Link>}
                </td>
                <td>
                  {get(author, 'firstName')} {get(author, 'lastName')}
                </td>
                <td>{createdAt && <div><FormattedDate value={createdAt} /> <FormattedTime value={createdAt} /></div>}</td>
                <td>
                  {get(category, 'translationText') || get(category, 'value')}
                </td>
                <td>
                  {get(section, 'translationText') || get(section, 'value')}
                </td>
                <td>
                  <Status state={isParentalConsentFile} check noWaiting />
                </td>
                <td>
                  <Status state={isAssessorReportFile} check noWaiting />
                </td>
                <td>
                  <Status state={isObservationFile} check noWaiting />
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      secondary
                      tiny
                      type="button"
                      intlKey="button.edit"
                      onClick={() =>
                        this.props.onEditFile({
                          id,
                          fileUrl,
                          title,
                          description,
                          author,
                          createdAt,
                          canBeDeleted,
                          isAssessorReportFile,
                          isParentalConsentFile,
                          section,
                          category
                        })}
                    >
                      Edit
                    </Button>

                    <Button
                      tiny
                      type="button"
                      intlKey="button.view_more"
                      onClick={() =>
                        this.props.onDisplayDetail({
                          id,
                          fileUrl,
                          title,
                          description,
                          author,
                          createdAt,
                          canBeDeleted,
                          isAssessorReportFile,
                          isParentalConsentFile,
                          isObservationFile,
                          section,
                          category
                        })}
                    >
                      View more
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default enhance(FilesList)
